
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Avatar, Button, FloatButton, message, Row, Space, Table} from "antd";
import Modal from "antd/es/modal";
import {use} from "i18next";
import axios from "axios";
import {Link} from "react-router-dom";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import SmileTwoTone from "@ant-design/icons/lib/icons/SmileTwoTone";
import EmojiContainer from "../EmojiContainer";
import Col from "antd/es/grid/col";
import List from "antd/es/list";
import MehOutlined from "@ant-design/icons/lib/icons/MehOutlined";
import Tooltip from "antd/es/tooltip";
import Image from "antd/es/image";
import { useSpring, animated } from '@react-spring/web'
import {globalData} from "../../util/util";

let cd = 0
let last = "0 0 0 0 0 0"

export default (prop) => {

    const {t} = useTranslation()
    const [isOpen, setIsOpen] = useState(false);

    const [data, setData] = useState([])
    const [flag, setFlag] = useState(false)

    const [keys, setKeys] = useState([0,0,0,0,0,0])

    const [key, setKey] = useState(0)

    const keyName = {
        0: "1",
        1: "2",
        2: "3",
        3: "4",
        4: "5",
        5: "6",
    }

    let shift = false

    function kewDownUp(e) {
        if (e.key === "Shift") {
            if (e.type === 'keydown') {
                shift = true
            } else if (e.type === 'keyup') {
                shift = false
            }
        }
    }

    useEffect(() => {
        window.addEventListener('keydown', kewDownUp)

        window.addEventListener('keyup', kewDownUp)

        return () => {
            window.removeEventListener('keydown', kewDownUp)
            window.removeEventListener('keyup', kewDownUp)
        }
    })

    function load() {
        let str = localStorage.getItem('touhou_emoji_keys')
        if (str) {
            let arr = JSON.parse(str)
            setKeys(arr)
        }
    }

    function bindingCallback(emoji) {
        if (flag) {
            keys[key] = emoji
            setKeys([...keys])
            setFlag(false)
            return
        }

        if (new Date().getTime() - cd < 1000 * 2) {
            message.warning(t('emoji.sendWarning')).then()
            return
        }

        axios.post(`${axios.defaults.localURL}sendEmoji`, `${emoji} ${shift ? 2 : 0}`).then(res => {
            if (res === "ok") {
                cd = new Date().getTime()
                message.success(t('emoji.sendSuccess')).then()
            } else {
                message.error(t('emoji.sendError')).then()
            }

        })

    }


    useEffect(() => {
        if (isOpen) {
            load()
            axios.get('emoji/list').then(res => {
                setData(res)
            })
        }
    }, [isOpen])

    useEffect(() => {




        let newSet = keys.join(" ");
        if (last === newSet) {
            last = newSet
            return
        }
        last = newSet

        if (!isOpen) {
            return
        }

        localStorage.setItem('touhou_emoji_keys', JSON.stringify(keys))
        let self = globalData('self')

        if (self.handle) {
            axios.post(`${axios.defaults.localURL}setConf`,
                `${self.handle} ${self.clanTag ? self.clanTag : '@'} ${newSet}`).then(res => {})
        }

        // axios.post(`${axios.defaults.localURL}setConf2`,
        //     `${newSet}`).then(res => {})
    }, [keys])




    return <>
        <Modal width={700} style={{}} title="" open={isOpen} onCancel={() => setIsOpen(false)} cancelButtonProps={{style: {display: "none"}}} okButtonProps={{style: {display: "none"}}}>
            <div style={{padding: "20px"}} >
                <Space size={30}>
                    <EmojiContainer data={data} click={bindingCallback} />
                    <Space direction={"vertical"}>
                        {
                            <animated.div style={useSpring({
                                from: { opacity: 0 },
                                to: { opacity: 1 },
                                loop: true,
                                delay: 500,
                            })}>{
                                <div style={{height: "30px"}}>{flag ? <h3 style={{color: '#52c41a'}}><b>{t('emoji.bindingTip2')}</b></h3> : null}</div>
                            }</animated.div>
                        }
                        <List
                            itemLayout="horizontal"
                            dataSource={keys}
                            renderItem={(item, index) => (
                                <List.Item>
                                    <Space>
                                        <Tooltip title={t('emoji.bindingTip')}>
                                            {
                                                !item ? <Button onClick={() => {
                                                        setFlag(true)
                                                        setKey(index)

                                                    }} shape="circle" icon={<MehOutlined />}

                                                    />
                                                    :
                                                    <Image  onClick={() => {
                                                        setFlag(true)
                                                        setKey(index)
                                                    }} style={{}} draggable={"false"} src={`${axios.defaults.fileURL}touhou/emoji/${item}.png`} preview={false} width={40} height={40}

                                                            onContextMenu={() => {
                                                                keys[index] = 0
                                                                setKeys([...keys])
                                                            }}
                                                    />
                                            }

                                        </Tooltip>

                                        <h3>{keyName[index]}</h3>
                                    </Space>
                                </List.Item>
                            )}
                        />
                        <h4 style={{color: '#f5222d'}}>{t('emoji.help')}</h4>
                    </Space>
                </Space>
            </div>
        </Modal>
        <FloatButton icon={<SmileTwoTone style={{ fontSize: "20px" }} twoToneColor="#d48806" />} style={{ bottom: "120px" }} onClick={() => setIsOpen(true)} />
    </>

}
